const getters = {
	token: state => state.user.token,
	admin_name: state => state.user.admin_name,
}

export default getters
